import { useContext } from "react";
import { AppContext } from "../../App";
import axios from "axios";
import { Button, CssBaseline, CssVarsProvider, DialogContent, DialogTitle, FormControl, FormLabel, Input, Modal, ModalDialog, Select, Option, Stack, ModalClose } from "@mui/joy";
import { Project } from "../../types";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import React from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, TimeField } from "@mui/x-date-pickers";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

import {
    Experimental_CssVarsProvider as MaterialCssVarsProvider,
    experimental_extendTheme as extendMaterialTheme,
    THEME_ID
} from "@mui/material/styles";
import { calculateNewValue } from "@testing-library/user-event/dist/utils";

const materialTheme = extendMaterialTheme();



export function AddProject(props: { open: boolean, setOpen: React.Dispatch<React.SetStateAction<boolean>>, snackbarConfig: (snackbarType: 'danger' | 'neutral' | 'primary' | 'success' | 'warning', snackbarInfo: string) => void }) {
    const token = useContext(AppContext).token;

    // States for the Create termin function
    const [loading, setLoading] = React.useState<boolean>(false);
    const [date, setDate] = React.useState<Dayjs | null>(dayjs("2024-09-09"));
    const [end, setEnd] = React.useState<Dayjs | null>(dayjs("2024-09-09"));
    const [name, setName] = React.useState<string>("Brez imena");
    const [type, setType] = React.useState<string>("V");

    const [stringDate, setStringDate] = React.useState<string>("2024-09-09");
    const [stringStart, setStringStart] = React.useState<string>("HH:mm");
    const [stringEnd, setStringEnd] = React.useState<string>("HH:mm");

    React.useEffect(() => {
        date != null ? setStringDate(date.format("YYYY-MM-DD")) : setStringDate("null");
        date != null ? setStringStart(date.format("HH:mm")) : setStringStart("null");
        end != null ? setStringEnd(end.format("HH:mm")) : setStringEnd("null");
    }, [date, end]);

    // Make a POST request to the API to create a new project
    
    function addProject(name: string, organizer: number, end_date: string) {
        axios.post('https://hudniki.pythonanywhere.com/endpoints/projects/', {
            'name': name,
            'organizer': 1,
            'end_date': end_date,
        }, {
            headers: {
                'Authorization': `Token ${token}`
            }
            
        }).then(
            (response) => {
                props.snackbarConfig('success', 'Nov projekt uspešno dodan');
                console.log(response)}
        ).catch(
            (error) => {
                props.snackbarConfig('danger', 'Napaka pri dodajanju projekta: ' + error);
                console.log(error)}
        );
    }
  
  
    return (
    <>
            <MaterialCssVarsProvider theme={{ [THEME_ID]: materialTheme }}>
                <CssVarsProvider>
                    <CssBaseline />
        <Modal 
            open={props.open} 
            onClose={() => {props.setOpen(false)}}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
                <ModalDialog>
                    <ModalClose />
                    <DialogTitle>Dodaj projekt</DialogTitle>
                        <DialogContent>Izpolni vse podatke</DialogContent>
                            <form
                                onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                                    event.preventDefault();
                                    setLoading(true);
                                    addProject(name, 1, String(date?.format("YYYY-MM-DD")))
                                    props.setOpen(false);
                                    setLoading(false);
                                }}
                            >
                                <FormControl>
                            <FormLabel>Naslov projekta</FormLabel>
                                <Input required onChange={(event) => {setName(event.target.value)}} />
                            </FormControl>
                                <Stack spacing={2}>
                                    <FormControl>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                            <DatePicker 
                                            label="Kdaj se projekt konca" 
                                            value={date}
                                            onChange={(newValue) => {
                                                setDate(newValue)
                                                // setEnd(newValue)
                                            }}
                                            format="DD.MM.YYYY"
                                            />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </FormControl>
                            
                            <Button
                                loading={loading} 
                                type="submit">
                                    Dodaj
                                </Button>
                        </Stack>
                    </form>
                </ModalDialog>
        </Modal>
        </CssVarsProvider>
        </MaterialCssVarsProvider>
    </>
  );
}